import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = { class: "row q-mt-sm" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "q-ml-sm" }
const _hoisted_5 = { class: "text-grey-7 tw-not-italic" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "q-my-sm tw-grid tw-grid-cols-4 tw-gap-4" }
const _hoisted_8 = { class: "row q-mt-sm" }
const _hoisted_9 = { class: "q-pt-sm" }
const _hoisted_10 = { class: "row q-mt-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_chip_list = _resolveComponent("chip-list")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_form_store_profile = _resolveComponent("form-store-profile")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("a", {
          target: "_blank",
          href: `
          https://www.google.com/maps/place/${(_ctx.store.street as string).replace(' ','+')},+${(_ctx.store.city as string).replace(' ', '+')},+${_ctx.store.state}
          `
        }, [
          _createVNode(_component_q_btn, {
            round: "",
            color: "secondary",
            icon: "map"
          })
        ], 8, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("address", _hoisted_5, [
          _createTextVNode(_toDisplayString(_ctx.store.street), 1),
          _hoisted_6,
          _createTextVNode(" " + _toDisplayString(_ctx.store.city) + ", " + _toDisplayString(_ctx.store.state), 1)
        ])
      ])
    ]),
    _createVNode(_component_chip_list, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setModal('store_items', _ctx.modalChipItems))),
      items: _ctx.storeItems
    }, null, 8, ["items"]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", null, [
        _createVNode(_component_q_item_section, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_label, {
              overline: "",
              class: "text-grey-7"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.storeItemLabel('store_number')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_label, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.store.store_number), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_q_item_section, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_label, {
              overline: "",
              class: "text-grey-7"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.storeItemLabel('chain_name')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_label, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.store.chain_name), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_q_item_section, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_label, {
              overline: "",
              class: "text-grey-7"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.storeItemLabel('chain_short_name')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_label, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.store.chain_short_name), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_q_item_section, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_label, {
              overline: "",
              class: "text-grey-7"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.storeItemLabel('class_of_trade')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_label, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.store.class_of_trade), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_q_item_section, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_label, {
              overline: "",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (
              _ctx.setModal('store_manager', {
                contact_name: { value: _ctx.store.contact_name ? _ctx.store.contact_name : '', type: 'text' },
              })
            ), ["stop"])),
              class: "text-grey-7"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.storeItemLabel('store_manager')) + " ", 1),
                _createVNode(_component_q_icon, {
                  name: "edit",
                  size: "10px"
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_label, {
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (
              _ctx.setModal('store_manager', {
                contact_name: { value: _ctx.store.contact_name ? _ctx.store.contact_name : '', type: 'text' },
              })
            ), ["stop"]))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.store.contact_name), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_q_item_section, {
        class: "q-pa-none col-3",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.modalStoreNotes = true))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_label, {
            overline: "",
            class: "text-grey-7",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.setModal('notes', { notes: { type: 'textarea', value: _ctx.store.notes } })), ["stop"]))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.storeItemLabel('notes')) + " ", 1),
              _createVNode(_component_q_icon, {
                name: "edit",
                size: "10px"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_q_item_label, {
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.setModal('notes', { notes: { type: 'textarea', value: _ctx.store.notes } })), ["stop"]))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.store.notes), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_q_btn, {
        "no-caps": "",
        rounded: "",
        flat: "",
        color: "primary",
        label: _ctx.storeItemLabel('suggestEdit'),
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.modalStoreRecap = true))
      }, null, 8, ["label"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_q_item, { class: "q-pa-none col-3" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.editModal,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editModal) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_form_store_profile, {
          header: _ctx.modalData.header,
          data: _ctx.modalData.data,
          "store-id": (_ctx.store.store_id as number)
        }, null, 8, ["header", "data", "store-id"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}